export const valueToCurrencyFormat = (value: number | string): string => {
  if (typeof value === 'string') value = parseFloat(value);
  const newValue = value.toLocaleString('es-AR', {
    style: 'currency',
    currency: 'ARS',
  });

  return newValue.replace(/\u00A0/g, '');
};
